import { Entity } from './entity'
import { Point, neighbors } from '../math/point';
import { Vector, asVector, subtract } from '../math/vector';
import { Transform, fromRotation } from '../math/transform';
import { lt, gt, eq } from '../math/util';

class Parabola {
  constructor(readonly a: number, readonly b: number) {}

  // parabola with vertex on y-axis
  f(y: number): number {
    const a = this.a
    const b = this.b

    return -a/(b*b)*(y+b)*(y-b) // a * (y+b) * (y-b)
  }

  within(p: Point): boolean {
    return gt(p.y, 0) && gt(this.f(p.x) - p.y, 0)
  }
}

export class VehicleModel {
  protected readonly transform = new Transform()
  protected readonly parabola: Parabola

  constructor(
    readonly speed: number,    // how much distance forward during move action
    readonly turnSpeed: number // how much distance sideways during move action
    ) {
      this.parabola = new Parabola(this.speed, this.turnSpeed)
    }

  maxVelocity(body: Entity, v0: Vector): Vector {
    const v = v0.rotate(-body.heading)

    // destination is behind vehicle
    if (lt(v.x, 0)) {
      const max = new Vector(0, Math.sign(v.y) * this.turnSpeed)
      return max.rotate(body.heading)
    }

    // destination is directly infront of vehicle
    if (eq(v.y, 0)) {
      const maxSpeed = Math.min(v.length(), this.speed)
      return v0.normalize(maxSpeed)
    }

    const slope = v.x/v.y
    const a = this.speed
    const b = this.turnSpeed
    // -(slope*b^2)/(2*a)
    const m = -(slope*b*b)/(2*a)

    const y0 = m + Math.sign(slope)*Math.sqrt(m*m + b*b)
    const x0 = this.parabola.f(y0)

    const v1 = new Vector(x0, y0)

    return v1.rotate(body.heading)
  }

  canMove(body: Entity, p: Point): boolean {
    const mat = fromRotation(-body.heading)

    const p0 = subtract(p, asVector(body.position))
    const p1 = this.transform.convert(p0, mat)

    return gt(p1.x, 0) && gt(this.parabola.f(p1.y) - p1.x, 0)
  }

  // allowedMoves(body: Body): Point[] {
  //   return neighbors(gameGrid.toGrid(body.position), gameGrid.toGridScalar(this.speed)).
  //     map(p => gameGrid.toWorld(p)).
  //     filter(p => this.canMove(body, p))
  // }
}
